<template>
  <v-app id="inspire" class="grey lighten-3">
   <UserNavbar/>
   <v-main>
     <v-flex>
         <v-container
        fluid
      >
        <v-layout px-5  row class="mt-1">
          <v-flex xs6 md10 dense>
            <div class="subtitle" style=" font-size: 0.92em;">Dashboard</div>
          </v-flex>
          <v-flex class="text-right" xs6 md2 >
            <v-spacer/>
             <v-breadcrumbs class="pa-0" :items="crumbItems" id="crumbs">
              <template v-slot:item="{item}">
                <v-breadcrumbs-item :href="item.href" :disabled="item.disabled" @click="breadCrumbClick(item)" style=" font-size: 0.92em;">
                  {{item.text}}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
        <UserHeader/>
        <UserAddUser v-if="isAdmin"/>
      </v-container>
     </v-flex>
   </v-main>
  </v-app>
</template>

<script>
import UserNavbar from '@/components/UserNavbar'
import UserHeader from '@/components/UserHeader'
import UserAddUser from '@/components/UserAddUser'

export default {
  data: () => {
    return {
      isAdmin: false,
      crumbItems: [
        {
          text: 'Home',
          disabled: false,
          href: '#',
          route: '/userHome'
        },
        {
          text: 'Register Users',
          disabled: false,
          href: '#',
          route: '/userAddUser'
        }
      ]
    }
  },
  components: {
    UserNavbar,
    UserHeader,
    UserAddUser
  },
  mounted: [
    function () {
      var id = localStorage.getItem('kwkk')
      window.axios.post('/userAdmin/findUserAdmin', { userId: id })
        .then((response) => {
          if (response.data.length !== 1) {
            this.$router.push('/userHome')
          } else {
            this.isAdmin = true
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(() => {
        })
    }
  ],
  methods: {
    breadCrumbClick (item) {
      this.$router.push(item.route).catch(() => {
        window.location.reload()
      })
    }
  }
}
</script>

<style scoped>
#crumbs{
  align-content: right;
  justify-content: right;
}
</style>
